import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { CategoriesIcon, EditIcon, NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../constants";

const AddEditElement = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const imageKey = useRef("");
  const logoKey = useRef("");
  const logoWhiteKey = useRef("");
  const videoKey = useRef("");
  const editor = useRef(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    subtitle: "",
    title: "",
    description: "",
    image: "",
    logo: "",
    logo_white: "",
    isActive: true,
    color: "",
    video: "",
  });
  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const handleSelectChangeColor = (newValue) => {
    setItem({ ...item, color: newValue });
    setColorError("");
  };
  const [colorError, setColorError] = useState("");
  const [titleError, setTitleError] = useState("");
  const handleChangeSubtitleEn = (newValue) => {
    setItem({ ...item, subtitleEn: newValue });
  };
  const handleChangeSubtitle = (newValue) => {
    setItem({ ...item, subtitle: newValue });
  };
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };

  const [files, setFiles] = useState([]);
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts jpegs and pngs (Required size: 1080x1920 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "element");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesLogo, setFilesLogo] = useState([]);
  const handleDropZoneLogo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesLogo((filesLogo) => [...filesLogo, ...acceptedFiles]),
    []
  );
  const fileUploadLogo = !filesLogo.length && (
    <DropZone.FileUpload
      actionHint={
        "Accepts svgs, jpegs and pngs (Required size: 200x200 pixels)"
      }
    />
  );
  const uploadedFilesLogo = filesLogo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesLogo[filesLogo.length - 1].type)
              ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesLogo[filesLogo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesLogo[filesLogo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImageLogo = (filesLogo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "element");
    form_data.append("image", filesLogo[filesLogo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        console.log(result.data);
        logoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo:
            validImageTypes.indexOf(filesLogo[filesLogo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesLogoWhite, setFilesLogoWhite] = useState([]);
  const handleDropZoneLogoWhite = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesLogoWhite((filesLogoWhite) => [
        ...filesLogoWhite,
        ...acceptedFiles,
      ]),
    []
  );
  const fileUploadLogoWhite = !filesLogoWhite.length && (
    <DropZone.FileUpload
      actionHint={
        "Accepts svgs, jpegs and pngs (Required size: 200x200 pixels)"
      }
    />
  );
  const uploadedFilesLogoWhite = filesLogoWhite.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(
              filesLogoWhite[filesLogoWhite.length - 1].type
            )
              ? window.URL.createObjectURL(
                  filesLogoWhite[filesLogoWhite.length - 1]
                )
              : NoteIcon
          }
        />
        <div>
          {filesLogoWhite[filesLogoWhite.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesLogoWhite[filesLogoWhite.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImageLogoWhite = (filesLogoWhite) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "element");
    form_data.append("image", filesLogoWhite[filesLogoWhite.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        logoWhiteKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo_white:
            validImageTypes.indexOf(
              filesLogoWhite[filesLogoWhite.length - 1].type
            ) > 0
              ? window.URL.createObjectURL(
                  filesLogoWhite[filesLogoWhite.length - 1]
                )
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [imageError, setImageError] = useState("");

  const [filesVideo, setFilesVideo] = useState([]);
  const handleDropZoneDropVideo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesVideo((filesVideo) => [...filesVideo, ...acceptedFiles]),
    []
  );
  const fileUploadVideo = !filesVideo.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFilesVideo = filesVideo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesVideo[filesVideo.length - 1].type)
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesVideo[filesVideo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesVideo[filesVideo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendVideo = (filesVideo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "element");
    form_data.append("video", filesVideo[filesVideo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        videoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          video:
            validImageTypes.indexOf(filesVideo[filesVideo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/elements/${id}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            color: result?.data?.data?.color ? result.data.data.color : "",
            title: result?.data?.data?.title ? result.data.data.title : "",
            subtitle: result?.data?.data?.subtitle
              ? result.data.data.subtitle
              : "",
            description: result?.data?.data?.description
              ? result.data.data.description
              : "",

            image: result?.data?.data?.background_image
              ? result?.data?.data?.background_image
              : "",
            logo: result?.data?.data?.image_colored
              ? result?.data?.data?.image_colored
              : "",
            logo_white: result?.data?.data?.image_white
              ? result?.data?.data?.image_white
              : "",
            video: result?.data?.data?.video
              ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
              : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/elements/${id}`)
      .then((result) => {
        navigate("/admin/elements");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Element`}
      backAction={{ onAction: () => navigate("/admin/elements") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.title}
              onChange={handleChangeTitle}
              label="Title"
              error={titleError}
            />
            <TextField
              value={item.subtitle}
              onChange={handleChangeSubtitle}
              label="Subtitle"
            />
          </FormLayout.Group>
          <Select
            label="Color"
            options={[
              {
                label: "None",
                value: "",
              },
              {
                label: "Earth",
                // (
                //   <span>
                //     <span
                //       style={{
                //         display: "inline-block",
                //         width: "12px",
                //         height: "12px",
                //         backgroundColor: "#9F654A",
                //         marginRight: "8px",
                //         verticalAlign: "middle",
                //       }}
                //     ></span>
                //     Earth
                //   </span>
                // )
                value: "#9F654A",
              },
              {
                label: "Air",
                value: "#DCC0A8",
              },
              {
                label: "Fire",
                value: "#CC984D",
              },
              {
                label: "Water",
                value: "#93A096",
              },
              {
                label: "Events",
                value: "#c87e3c",
              },
            ]}
            onChange={handleSelectChangeColor}
            value={item.color}
            placeholder="Please select"
            error={colorError}
          />
          {item.color === "#CC984D" ? (
            <Button
              fullWidth
              variant="primary"
              icon={EditIcon}
              onClick={() => {
                localStorage.setItem("element", "fire");
                navigate(`/admin/elements/${id}/categories`);
              }}
            >
              Categories
            </Button>
          ) : item.color === "#93A096" ? (
            <Button
              fullWidth
              variant="primary"
              icon={EditIcon}
              onClick={() => {
                localStorage.setItem("element", "water");
                navigate(`/admin/elements/${id}/categories`);
              }}
            >
              Categories
            </Button>
          ) : null}
          <TextField
            value={item.description}
            onChange={handleChangeDescription}
            label="Description"
            multiline={4}
          />
          {/* <Editor
            apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
            value={item.description}
            init={{
              branding: false,
              height: 200,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help|code",
            }}
            onEditorChange={handleChangeDescription}
          /> */}

          <Text>Logo (Colored)</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.logo ? item.logo : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                onDrop={handleDropZoneLogo}
                allowMultiple={false}
                onDropAccepted={sendImageLogo}
              >
                {uploadedFilesLogo}
                {fileUploadLogo}
              </DropZone>
            </div>
          </div>

          <Text>Logo (White)</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail
                size="large"
                source={item.logo_white ? item.logo_white : ""}
              />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                onDrop={handleDropZoneLogoWhite}
                allowMultiple={false}
                onDropAccepted={sendImageLogoWhite}
              >
                {uploadedFilesLogoWhite}
                {fileUploadLogoWhite}
              </DropZone>
            </div>
          </div>
          <Text>Background Image</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>

          <Text>Video</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.video ? item.video : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                onDrop={handleDropZoneDropVideo}
                allowMultiple={false}
                onDropAccepted={sendVideo}
                accept=".mp4"
              >
                {uploadedFilesVideo}
                {fileUploadVideo}
              </DropZone>
            </div>
          </div>
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setActiveDelete(true);
              }}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.title) {
      !item.title && setTitleError("This field is required");
      // !item.color && setColorError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("color", item.color);
      item.title && form_data.append("title", item.title);
      form_data.append("subtitle", item.subtitle);
      form_data.append("description", item.description);
      imageKey.current &&
        form_data.append("background_image", imageKey.current);
      videoKey.current && form_data.append("video", videoKey.current);
      logoKey.current && form_data.append("image_colored", logoKey.current);
      logoWhiteKey.current &&
        form_data.append("image_white", logoWhiteKey.current);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/elements`, form_data)
            .then((result) => {
              navigate("/admin/elements");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/elements/${id}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditElement;
